import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'analysisStats',
  initialState: {
    data: {
      ages: [],
      publications: [],
      selectedAge: null,
      selectedPublication: null,
      resume: {
        active_students: 0,
        active_teachers: 0,
        registered_students: 0,
        registered_teachers: 0,
        total_classes: 0,
        total_students_usage_time: 0,
        total_teachers_usage_time: 0,
        total_centers: 0,
      },
      stats: [],
    },
  },
  reducers: {
    setStats: (state, { payload: obj }) => {
      state.data = { ...state.data, ...obj };
    },
    setCurrentPublication: (state, { payload: publication }) => {
      state.data.selectedPublication = publication;
    },
    setCurrentAge: (state, { payload: age }) => {
      state.data.selectedAge = age;
    },
  },
});

export const { setStats, setCurrentPublication, setCurrentAge } = slice.actions;

export default slice.reducer;

export const selectStats = (state) => state.analysisStats.data;
